import { z } from 'zod';

const shellSchema = z.object({
  slug: z.string(),
  name: z.string(),
  shortName: z.string(),
  accent: z.string(),
  variant: z.enum(['client', 'owner']),
});
export type ShellData = z.infer<typeof shellSchema>;

/** Studio data embedded in the generated HTML shell (for a branded first paint). */
export function readShell(): ShellData | null {
  try {
    const node = document.getElementById('studio-shell');
    if (!node?.textContent) return null;
    const parsed = shellSchema.safeParse(JSON.parse(node.textContent));
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}
